export default "__VITE_ASSET__CtXZy9nX__"